const scrollHeightPercent = (e: any) => {
  return e.target?.scrollTop
    ? Math.round(
        (e.target.scrollTop / (e.target.scrollHeight - e.target.offsetHeight)) *
          100
      )
    : 0;
};
export default scrollHeightPercent;
